export const tenantErrorCodes = {
  DEVICES_ATTACHED_TO_TENANT_ERROR: 'DEVICES_ATTACHED_TO_TENANT_ERROR',
  COULD_NOT_GET_DEVICE_DATA: 'COULD_NOT_GET_DEVICE_DATA',
};
